import React from 'react';
import AppSidebar from '../components/Sidebar/AppSidebar';

export default function Sidebar({ isMobile }) {
    return <AppSidebar isMobile={isMobile} />;
}
